export { default } from "./PromoWidget";
